import service from '@/utils/server';

const modName='/bd/orderLocking/';
//初始化
export const initPage = data => {
  return service({
    url: modName + 'initPage',
    method: 'post',
    data
  });
};
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};
//初始化更新对象
export const initUpdate = data => {
  return service({
    url: modName + 'orderDetail',
    method: 'post',
    data
  });
};

//批量锁定
export const batchLocking = data => {
  return service({
    url: modName + 'batchLocking',
    method: 'post',
    data
  });
};

//取消批量锁定
export const batchCancelLocking = data => {
  return service({
    url: modName + 'batchCancelLocking',
    method: 'post',
    data
  });
};

//定金核对
export const batchDepositCheck = data => {
  return service({
    url: modName + 'batchDepositCheck',
    method: 'post',
    data
  });
};

//定金取消核对
export const batchCancelDepositCheck = data => {
  return service({
    url: modName + 'batchCancelDepositCheck',
    method: 'post',
    data
  });
};

//应收款核对
export const batchReceivablesCheck = data => {
  return service({
    url: modName + 'batchReceivablesCheck',
    method: 'post',
    data
  });
};

//应收款取消核对
export const batchCancelReceivablesCheck = data => {
  return service({
    url: modName + 'batchCancelReceivablesCheck',
    method: 'post',
    data
  });
};

//总利润核对
export const batchTotalProfitCheck = data => {
  return service({
    url: modName + 'batchTotalProfitCheck',
    method: 'post',
    data
  });
};

//总利润取消核对
export const batchCancelTotalProfitCheck = data => {
  return service({
    url: modName + 'batchCancelTotalProfitCheck',
    method: 'post',
    data
  });
};

//应收款调整
export const orderReceivableEdit = data => {
  return service({
    url: modName + 'orderReceivableEdit',
    method: 'post',
    data
  });
};

//模板下载
export const downloadTemplate = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'template/' + data.templateName,
    method: 'post',
    data
  });
};

//导入
export const batchLockingImport = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    headers: {
      "Content-Type": "multipart/form-data"
    },
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'import',
    method: 'post',
    data
  });
};

//导出
export const exportData = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'export',
    method: 'post',
    data
  });
};

//查询总利润
export const selectTotalProfit = data => {
  return service({
    url: modName + 'summaryAmount',
    method: 'post',
    data
  });
};

//转员处理
export const transferPersonnelEdit = data => {
  return service({
    url: modName + 'transferPersonnel',
    method: 'post',
    data
  });
};




// WEBPACK FOOTER //
// ./src/page/financial/orderLocking/api/index.js